const MAX_LENGTH = 3;

const compareModule = {
    namespaced: true,
    state: {
      compareList: {
        mtSemen: [],
        mtCell: []
      },
      context: 'mtCell'
    },
    getters: {
      getCompareList(state) {
        return state.compareList;
      },
      getCurrentContextCompareList(state) {
        return state.compareList[state.context];
      },
      getCompareListByMaterialType: (state) => (materialType) => {
        return state.compareList[materialType];
      },
      getContext(state) {
        return state.context;
      }
    },
    actions: {
      addToCompareList({commit, state}, {id, pk, materialType}) {
        if(state.compareList[materialType].length < MAX_LENGTH){
          commit('addToCompareList', {id, pk, materialType});
          return id;
        } else {
          return false;
        }
      },
      removeFromCompareList({commit, state}, {id, pk, materialType}) {
        let pkFound = state.compareList[materialType].find(e => e.pk == pk);
        if(pkFound) {
          commit('removeFromCompareList', {pk: pkFound.pk, materialType})
          return id;
        } else {
          return false;
        }
      },
      toggleCompareListItem({commit, state}, {id, pk, materialType}) {
        let pkFound = state.compareList[materialType].find(e => e.pk == pk);
        if(pkFound) {
          commit('removeFromCompareList', {pk: pkFound.pk, materialType})
          return id;
        } else {
          if(state.compareList[materialType].length < MAX_LENGTH){
            commit('addToCompareList', {id, pk, materialType});
            return id;
          } else {
            return false;
          }
        }
      },
      clearCompareList({commit,state}, materialType) {
        commit('setCompareList', {...state.compareList,
          [materialType]: []
        });
      },
      setContext({commit}, context) {
        commit('setContext', context)
      }
    },
    mutations: {
      addToCompareList(state, {id, pk, materialType}) {
        state.compareList[materialType].push({id, pk});
      },
      removeFromCompareList(state, {pk, materialType}) {
        state.compareList[materialType] = state.compareList[materialType].filter(e => e.pk != pk);
      },
      setCompareList(state, list) {
        state.compareList = list;
      },
      setContext(state, context) {
        state.context = context;
      }
    }
  }

  export default compareModule;